import "./Blog.module.css";
import Header from "@/reusable_sections/Header";
import FeaturedArticle from "./sections/FeaturedArticle";
import BlogPostsList from "./sections/BlogPostsList";
import SubscribeContactCta from "./sections/SubscribeContactCta";
import Footer from "@/reusable_sections/Footer";
export default function BlogPage() {
  return <div>
      <Header />
      <FeaturedArticle />
      <BlogPostsList />
      <SubscribeContactCta />
      <Footer />
    </div>;
}